var $7c9dc206185355b5$exports = {};
$7c9dc206185355b5$exports = {
    "dismiss": `Avvisa`
};


export {$7c9dc206185355b5$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
